/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Day_TitleInputs */

const en_mk_sol_day_title = /** @type {(inputs: Mk_Sol_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What a day looks like once it is running`)
};

const id_mk_sol_day_title = /** @type {(inputs: Mk_Sol_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seperti apa harinya setelah dipasang`)
};

/**
* | output |
* | --- |
* | "What a day looks like once it is running" |
*
* @param {Mk_Sol_Day_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_day_title = /** @type {((inputs?: Mk_Sol_Day_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Day_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_day_title(inputs)
	return en_mk_sol_day_title(inputs)
});